import { render, staticRenderFns } from "./R2s1flight.vue?vue&type=template&id=614ce55b&"
import script from "./R2s1flight.vue?vue&type=script&lang=js&"
export * from "./R2s1flight.vue?vue&type=script&lang=js&"
import style0 from "./R2s1flight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports